import { ILevel, TTypeLevel } from '@/app/shared/components/program/constants'

export const getActiveLevel = (currentLevel: ILevel, activeLevel: ILevel) => {
  return +currentLevel.id <= +activeLevel.id ? undefined : 'bordered'
}

export const activeTypeLevel = (slug: TTypeLevel, data: ILevel) => {
  return data[slug]
}

export const getActiveTypeLevel = (slug: TTypeLevel, data: ILevel[]) => {
  return data.findIndex((el) => el[slug])
}
